"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AirwebTicketLegacyTransitService = void 0;
class AirwebTicketLegacyTransitService {
    constructor(client) {
        this.client = client;
    }
    async getODStops(networkId, productId, originKey) {
        const response = await this.client.http.get(`Transit/getODStops`, {
            params: {
                network_id: networkId,
                product_id: productId,
                origin_stop: originKey || undefined,
            },
        });
        return response.data.stops;
    }
    async getODTrips(networkId, productId, originKey, destinationKey) {
        const response = await this.client.http.get(`Transit/getODTrips`, {
            params: {
                network_id: networkId,
                product_id: productId,
                origin_stop: originKey,
                destination_stop: destinationKey,
            },
        });
        return response.data.trips;
    }
}
exports.AirwebTicketLegacyTransitService = AirwebTicketLegacyTransitService;
//# sourceMappingURL=transit.service.js.map